import React, { Component } from 'react';
import {InputItem, List, Button, Flex, Icon} from 'antd-mobile';
import InputNumber from '../../../components/InputNumber';
import '../../stock-check/index.css'
let HEIGHT = 90;
export default class Day extends Component {
  constructor (props) {
    super(props);
    this.state = {
      value: ''
    }
  }
  ok = () => {
    this.props.onConfirm(this.state.value)
  };
  cancel = () => {
    const {value} = this.props;
    this.setState({
      value: value
    });
    this.props.onCancel()
  };
  onChange = (value) => {
    this.setState({
      value:value
    });
  };
  componentWillMount() {
    this.setState({
      value: this.props.value
    })
  }
  AddRemove = () => {
    const {value} = this.state;
    return <Flex>
      <div className="remove-circle-icon"
          onClick={() => {
        if (value * 1 < 1) {
          return;
        }
        this.setState({
          value: value * 1 - 1
        })
      }}
      />
      <div
        className="add-circle-icon"
        onClick={() => {
          this.setState({
            value: value * 1 + 1
          })
        }}
        style={{marginLeft: 20}}
      />
    </Flex>
  };
  render() {
    const {value} = this.state;
    return (
      <List>
        <List >
         <div style={{padding: '10px 15px'}}>
           <InputNumber className="input-bordered"
               extra={this.AddRemove()}
               onChange={(value) => {
                          this.setState({
                            value
                          })
                        }}
               style={{textAlign: 'center'}}
               type="number"
               value={value}
           >
             天数
           </InputNumber>
         </div>
        </List>

        <div style={{padding: '25px 10px'}}>
          <Flex>
            <Flex.Item>
              <Button onClick={this.cancel}>取消</Button>
            </Flex.Item>
            <Flex.Item>
              <Button onClick={this.ok}
                  type="primary"
              >确定</Button>
            </Flex.Item>
          </Flex>
        </div>

      </List>
    )
  }
}
